<template>
  <select>
    <slot></slot>
  </select>
</template>
<script>

import {isEmpty,isEqual,isEqualWith} from "lodash";


export default {
  props: {
    sortable:{
      type: Boolean,
      default: false
    },
    value: {
      type: [String,Number,Array],
    },
    settings: {
      type: Object,
      default: () => {}
    },
    options: {
      type: Array,
      default: () => []
    },
    templateResult: {
      type: Function
    },
  },
  mounted: function() {
    var vm = this;
    $(this.$el)
      // init select2
      .select2({ data: this.options, ...this.settings,templateSelection:this.formatState, templateResult:this.templateResult })
      .val(this.value)
      .trigger("change")
      // emit event on change.
      .on("change", function(val) {
      if(isEmpty($(this).val()) && isEmpty(vm.value)){
        // if both have falsy values
        // do nothing
      }else{
        if(!isEqual($(this).val(),vm.value)){
          vm.$emit("input", $(this).val());
        }
      }

      })
      .on('select2:select',function(e){
        vm.$emit('option:selected',e.params.data.id);
      })
      .on('select2:unselect',function(e){
        vm.$emit('option:unselected',e.params.data.id);
      });

      this.initSortable();
  },
  methods:{
    initSortable(){
      var vm = this;
      if(this.sortable){
        $("ul.select2-selection__rendered").sortable({
          containment: 'parent',
          stop: function(event, ui) {
            var data = $(vm.$el).select2('data');

            var value = Array.from($(event.target).find('li:not(.select2-search)').map(function () {
              var text = $(this).attr('title');
              var id = data.find(x => x.text == text).id;
              var $option = $(vm.$el).children(`[value=${id}]`);
              $option.detach();
              $(vm.$el).append($option);
            }));

            $(vm.$el).trigger('change')
          }
        });
      }
    },
    formatState(state){
      var vm = this;
      var $text = $(`<span data-option-id="${state.id}">${state.text}</span>`);

      $text.on('click touchend', function (evt) {
        evt.stopPropagation();
        evt.preventDefault();
        vm.$emit('option:clicked',$(this).data('option-id'));
      });

      return $text;
    }
  },
  watch: {
    value: function(value) {

      this.$el.value = value;

      // update value
      $(this.$el)
        .val(value)
        .trigger("change");

    },
    settings: {
        handler: function(settings) {
          $(this.$el)
            .empty()
            .select2({data: this.options,...settings,templateSelection:this.formatState, templateResult:this.templateResult})
            .val(this.value)
            .trigger("change");
          
          this.initSortable();

        },
        deep: true
    },
    options: {
        handler: function(options) {
          $(this.$el)
            .empty()
            .select2({data: options,...this.settings,templateSelection:this.formatState, templateResult:this.templateResult})
            .val(this.value)
            .trigger("change");
          
          this.initSortable();

        },
        deep: true
    }
  },
  destroyed: function() {
    $(this.$el)
      .off()
      .select2("destroy");
  }

}
</script>